import {
  type ApiDimensionValues,
  otherValuesId,
  type DimensionValueId,
  unassignedValuesId,
} from '../models/dimensionValues';

export const convertDimensionValueFromApi = (
  apiDimensionValues: ApiDimensionValues,
): DimensionValueId => {
  if (apiDimensionValues === null) {
    return { type: 'other', value: otherValuesId };
  }
  const [firstValue] = apiDimensionValues;
  if (firstValue === undefined) {
    throw new Error(
      'ApiDimensionValues must contain at least one id to be converted to DimensionValueId',
    );
  }
  if (firstValue === null) {
    return { type: 'unassigned', value: unassignedValuesId };
  }
  return { type: 'specific', value: firstValue };
};

export const convertDimensionValueToApi = (
  dimensionValueId: DimensionValueId,
): ApiDimensionValues => {
  if (dimensionValueId.type === 'other') {
    return null;
  }
  if (dimensionValueId.type === 'unassigned') {
    return [null];
  }
  return [dimensionValueId.value];
};
